<template>
  <div id="app">
    <header-fo></header-fo>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <footer-fo></footer-fo>
  </div>
</template>

<script>
  import HeaderFo from '@/components/Header'
  import FooterFo from '@/components/Footer'
  import Banner from '@/components/Banner'
  import Highlight from '@/components/Highlights'
  import MenuEmp from '@/components/Menu'
  export default {
    name: 'app',
    components: { HeaderFo,FooterFo,MenuEmp, Banner,Highlight}
  }
</script>

<style lang="scss">
  @import './assets/sass/main.scss';
</style>



// WEBPACK FOOTER //
// App.vue?5188d2fc